import React, { Component } from 'react';

class AboutExtended extends Component {
  render() {
    const { data } = this.props;
    let publicUrl = process.env.PUBLIC_URL;
    let imgattr = 'image';

    return (
      <>
        {/* Hero Section */}
        <section className="p-80px-tb parallax bg-overlay opacity-5"
                 style={{backgroundImage: 'url(' + publicUrl + '/assets/img/about-bg.jpg)'}}>
          <div className="container">
            <div className="row">
              <div className="col-sm-8 offset-sm-2">
                <div className="section-title text-center text-white">
                  <h2 className="text-white">{data.pageTitle}</h2>
                  <p className="lead text-white">{data.pageSubtitle}</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Message Section */}
        <section className="p-80px-tb">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 md-m-50px-b">
                <div className="position-relative">
                  <div className="bordered-circle"></div>
                  <img
                    className="moveUpDown img-fluid rounded"
                    src={publicUrl + '/assets/img/service-section-bg.webp'}
                    alt="代表取締役 山田 健一"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="m-30px-b">
                  <h3 className="font-weight-bold m-15px-b">{data.message?.title}</h3>
                  <p className="lead text-primary m-20px-b">{data.message?.subtitle}</p>
                  <p className="text-muted m-20px-b">{data.message?.greeting}</p>
                  <p className="text-muted m-20px-b">{data.message?.content1}</p>
                  {data.message?.highlight && (
                    <div className="alert alert-primary p-30px m-30px-b">
                      <h5 className="alert-heading font-weight-bold">{data.message.highlight}</h5>
                    </div>
                  )}
                  <p className="text-muted m-20px-b">{data.message?.content2}</p>
                  <p className="text-muted m-20px-b">{data.message?.content3}</p>
                  <div className="signature m-30px-t">
                    <p className="font-weight-bold">{data.message?.signature}</p>
                    <p className="text-muted">{data.message?.signatureTitle}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Values Section */}
        {data.values && (
          <section className="p-80px-tb bg-light featured-2 position-relative">
            <div className="bordered-circle2"></div>
            <div className="container">
              <div className="row">
                <div className="col-md-12 text-center m-50px-b">
                  <h2 className="section-title font-weight-bold">{data.valuesTitle || '私たちの価値観'}</h2>
                </div>
              </div>
              {data.values.map((value, index) => (
                <div key={index} className="row align-items-center m-50px-b">
                  <div className={`col-lg-6 ${index % 2 === 1 ? 'order-lg-2' : ''}`}>
                    <div className="value-content p-40px">
                      <div className="value-number display-1 font-weight-bold text-primary m-20px-b">
                        {value.number}
                      </div>
                      <h3 className="font-weight-bold m-25px-b">{value.title}</h3>
                      <p className="lead text-primary font-weight-bold m-20px-b">
                        {value.highlight}
                      </p>
                      <p className="text-muted">
                        {value.content}
                      </p>
                    </div>
                  </div>
                  <div className={`col-lg-6 ${index % 2 === 1 ? 'order-lg-1' : ''}`}>
                    <img
                      src={value.image || `${publicUrl}/assets/img/${index === 0 ? 'service-section-bg.webp' : 'experience.png'}`}
                      alt={value.title}
                      className="img-fluid rounded"
                      style={{width: '100%', height: 'auto'}}
                    />
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}

        {/* Team Section */}
        {data.team && (
          <section className="p-80px-tb">
            <div className="container">
              <div className="row">
                <div className="col-sm-8 offset-sm-2">
                  <div className="section-title text-center m-50px-b">
                    <h2>{data.teamTitle || 'チーム'}</h2>
                  </div>
                </div>
              </div>
              <div className="row justify-content-md-center">
                {data.team.map((member, i) => (
                  <div key={i} className="col-lg-4 col-md-6">
                    <div className="service-box text-center p-40px m-10px-t m-10px-b">
                      <div className="team-avatar m-20px-b">
                        <div className="rounded-circle bg-primary text-white m-auto"
                             style={{width: '100px', height: '100px', lineHeight: '100px'}}>
                          <i className="icofont-user icofont-3x"></i>
                        </div>
                      </div>
                      <h4 className="font-weight-bold">{member.name}</h4>
                      <p className="text-primary">{member.role}</p>
                      <p className="text-muted">{member.bio}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )}
      </>
    );
  }
}

export default AboutExtended;